export default __webpack_public_path__ + "0d40e00f977a0273ee1261675ab5d9ec.svg";